import React, {Component} from 'react';
import toastr from "toastr";
import axios from "axios";
import update from 'immutability-helper';
import http from "../../services/httpService";
import {getCurrentUserName, setCurrentUserName, getCurrentUserId, getJwt} from "../../services/authService";
import FacebookSinglePost from './customPosts/FacebookSinglePost'
import FacebookMultiplePost from './customPosts/FacebookMultiplePost'
import NoFeeds from './feed/NoFeeds'
import WindowExpiredModal from "../modals/WindowExpiredModal";


import $ from 'jquery';
import authService from "../../services/authService";
// import ReactGA from "react-ga";
import SendTestMessageModal from "../modals/SendTestMessageModal";
import {Position, Tooltip} from "@blueprintjs/core";
import Campaigns from "./Campaigns";

class FacebookMessageCustomPost extends Component {
    state = {
        message: {},
        isEditing: false,

        saving: false,
        notifications: [],
        selectedOption: {
            value: "", label: "Please select page..."
        },
        selectedRadioOption: 'all',
        title: '',
        link: '',
        get_title_from_url: true,
        count_total_subscrib_sent: 0,
        count_push_subscrib: 0,
        count_fb_subscrib: 0,
        postStats: [],
        post_count_by_channel: [],
        count_type_subscrib: "all",
        showSingle: true,
        imageFromLink: "",
        multiple_custom: [{
            imageFromLink: "",
            title: "",
            get_title_from_url: true,
            link: "",
            id: 'multiple_custom_01',
            invalidLink: false
        }, {
            imageFromLink: "",
            title: "",
            get_title_from_url: true,
            link: "",
            id: 'multiple_custom_02',
            invalidLink: false
        }],
        loading_title_multiple_custom: [{
            loading_title: false
        }, {
            loading_title: false
        }],
        loaded: 0,
        loading_title: false,
        stopBroadcastModal: false,
        characterCount: 0,
        messageContent: '',
        emojiOpen: false,
        showMessage: false,
        subsFilter: 'all-subs',
        genderFilter: 'all-genders',
        native: false,
        invalidLink: false,
        windowModalActive: false,
        upgradeModalActive: false,
        sourcePlan: '',
        windowSentTo: 0,
        upgradeModalTitle: '',
        upgradeModalContent: '',
        error: '',
        selectedSourceFull: '',
        currentPlanLimitations: this.props.currentPlanLimitations,
        user: this.props.user,
        facebookPages: []
    };


    validURL = (str) => {
        let pattern = new RegExp('^(https?:\\/\\/)?' + // protocol
            '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
            '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
            '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
            '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
            '(\\#[-a-z\\d_]*)?$', 'i'); // fragment locator
        return !!pattern.test(str);
    }


    componentDidUpdate = async () => {
        if (this.state.currentPlanLimitations !== this.props.currentPlanLimitations) {
            // console.log('facebook general didUpdate- plan limitations')

            await this.setState({
                currentPlanLimitations: this.props.currentPlanLimitations
            })
        }
        if (this.state.selectedSource !== this.props.selectedSource) {
            // console.log('facebook general didUpdate- selected source')
            //console.log('entered willrecieveprops')
            //console.log('selected source id: ', this.props.selectedSource);

            let selectedSource = await this.props.user.sources.data.filter(source => source.id.toString() === this.props.selectedSource)
            //console.log('selectedSource full: ', selectedSource)
            this.setState({
                selectedSourceFull: selectedSource, selectedSource: this.props.selectedSource
            })
            if (selectedSource[0]) {

                //collecting remaining free messages
                let facebookPlatform = selectedSource[0].platforms.filter(platform => platform.platform === 'fb')
                //console.log('facebook platform :', facebookPlatform);

                await this.setState({
                    sourcePlan: selectedSource[0] ? selectedSource[0].platforms[0].plan : '',
                })
            }
            try {
                const result = await http.get('api/user/' + getCurrentUserId(), {headers: {authorization: getJwt()}});
                const data = result.data;
                this.setState({message: data});

            } catch (e) {
                toastr.error('Something went wrong... Please refresh page.')
            }
        }
    }

    sendFacebookNotification = async (title, link, pages = [], selectedTags) => {
        // console.log('selectedTags:', selectedTags);
        await this.setState({
            loaded: 1
        })
        //console.log('pages: ', pages);
        let selectedTagsIds = [];
        if (selectedTags) {
            selectedTags.map(selectedTag => {
                // console.log('selectedTag - map', selectedTag);
                selectedTagsIds = [...selectedTagsIds, selectedTag['id']]
            });
        }
        // console.log('selectedTagsIds:', selectedTagsIds);
        let tagSegmentation = 0;
        if (this.state.sourcePlan === 'free_plan') {
            tagSegmentation = 0;
        } else {
            if (selectedTagsIds.length > 0) {
                tagSegmentation = 1
            }
        }
        // console.log('tag segmentations:', tagSegmentation);
        let user_id = getCurrentUserId();
        if (pages.length) {
            // console.log("sendFacebookNotification pages   ", pages);
            const facebook_pages_shared = this.props.facebook_pages_shared || [];
            facebook_pages_shared.forEach(function (entry) {
                // console.log("sendFacebookNotification entry   ", entry);
                // opti onsSources[countOptionsSources] = { value: entry.id, text: entry.name };
                // countOptionsSources++;
                // if(entry.id.toString() === selectedSource.toString())
                // {
                //     source_name =  entry.name;
                // }
                pages.forEach(function (entryPage) {
                    // optionsSources[countOptionsSources] = { value: entry.id, text: entry.name };
                    // countOptionsSources++;
                    if (entry.page_id.toString() === entryPage) {
                        // source_name =  entry.name;
                        // console.log("sendFacebookNotification entryPage   ", entryPage);
                        user_id = entry.user_id;
                    }

                });
            });
        }
        // console.log('custom post user_id: ', user_id)
        if (!user_id) {
            user_id = this.state.user.id
        }
        let subsFilter = '';
        let genderFilter = '';
        if (this.state.subsFilter === 'all-subs') {
            subsFilter = 'all';
        } else {
            subsFilter = this.state.subsFilter
        }
        if (this.state.genderFilter === 'all-genders') {
            genderFilter = 'all'
        } else {
            genderFilter = this.state.genderFilter
        }

        let notification = {
            notification_title: title,
            notification_link: link,
            pages: pages,
            tag_segmentation: tagSegmentation,
            tag_ids: selectedTagsIds,
            message_text: this.state.messageContent,

            model_type: subsFilter,
            model_gender: genderFilter,
        };
        //alert(user_id);
        try {
            //console.log('single fb notification json: ', JSON.stringify(notification));
            //console.log('single fb notification: ', notification);
            //console.log('single post call: ', 'api/user/' + user_id + '/facebook_notification');

            const res_bot = await http.post('api/user/' + user_id + '/facebook_notification', notification, {headers: {authorization: getJwt()}});

            // console.log("single facebook notification result: ", res_bot);


            //const res_bot = await http.post('api/user/'+getCurrentUserId()+'/facebook_notification/'+pg_id, notification, {headers: {authorization: getJwt()}});

            //console.log("sendFacebookNotification res_bot.data   ", res_bot.data);
            // if ( res_bot.data.count === 0 ){
            //     toastr.error("It seems that you don't have any subscribers on the selected channels. Make sure you set up a campaign to get your followers to subscribe.");
            // }
            //console.log('Custom posts - res_bot.data.postStats: ', res_bot.data.postStats)
            //console.log('res bot count: ', res_bot.data.count);

            await this.setState({
                count_fb_subscrib: res_bot.data.count + this.state.count_fb_subscrib, //postStats: res_bot.data.postStats ? res_bot.data.postStats : []
            });
            // console.log('Post stats', this.state.postStats);
            // console.log('Count fb subs', this.state.count_fb_subscrib);

            const broadcast_click = {
                target: {
                    id: "broadcastClick"
                }
            };
            //console.log('broadcast_click: ', broadcast_click);

            await this.setCountOfSubscribers();
            await this.setSentCountSubscribersByChannel();

            //console.log('passed sets counts');

            const data = {
                count_total_subscrib_sent: this.state.count_total_subscrib_sent,
                fb_sent: res_bot.data.count, //postStats: res_bot.data.postStats,
                count_push_subscrib: this.state.count_push_subscrib,
                count_fb_subscrib: res_bot.data.count, //count_not_sent: res_bot.data.postStats[0].count_not_sent || 0,
                pages,
                type: 'fb_notification',
                error: res_bot.data.error ? res_bot.data.error : ''
            };

            //console.log('data after sets: ', data)

            //console.log('windowModalActive: ', this.state.windowModalActive);
            if (this.state.windowModalActive === false) {
                //console.log('modal activated');
                //console.log('broadcast_click: ', broadcast_click);
                //console.log('data: ', data);
                this.props.openModal(broadcast_click, data || 0);
            }
            await this.setState({
                loaded: 0
            })

        } catch (ex) {
            //console.log('single fb notification error')
            if (ex.response && ex.response.status === 404) {

                toastr.error("You don't have any subscribers on the selected channels. Make sure you set up a campaign to get your followers to subscribe.");

                await this.setState({
                    loaded: 0
                })
            }
            if (ex.response && ex.response.status === 401) {
                toastr.error(ex.response.data.message);
                this.props.history.push('/logout');
            }
        }

    }


    sendFacebookNotificationMultiple = async (posts, pages, selectedTags) => {
        let notification = [...posts];
        //console.log('selected tags - multiple: ', selectedTags)
        //console.log('multiple notification f start:', notification);
        let selectedTagsIds = [];
        selectedTags.map(selectedTag => {
            // console.log('selectedTag - map', selectedTag);
            selectedTagsIds = [...selectedTagsIds, selectedTag['id']]
        });
        // console.log('selectedTagsIds:', selectedTagsIds);
        let tagSegmentation = 0;
        if (selectedTagsIds.length > 0) {
            tagSegmentation = 1
        }

        try {
            //console.log('multiple enters try')
            this.props.loadingSubscribers(true);
            let subsFilter = '';
            let genderFilter = '';
            if (this.state.subsFilter === 'all-subs') {
                subsFilter = 'all';
            } else {
                subsFilter = this.state.subsFilter
            }
            if (this.state.genderFilter === 'all-genders') {
                genderFilter = 'all'
            } else {
                genderFilter = this.state.genderFilter
            }
            //console.log('subs filter: ', subsFilter);
            //console.log('gender: filter: ', genderFilter);


            // for (let i = 0; i < notification.length; i++) {
            //     if (!notification[i].link.startsWith('http')) {
            //         notification[i].link = 'http://' + notification.data[i].link
            //     }
            // }
            let newLink = '';
            notification.map(n => {
                let indicator = n.link.startsWith('http');
                if (indicator === false) {
                    newLink = 'http://' + n.link;
                    n.link = newLink
                }
            });
            let multipostData = {
                tag_ids: selectedTagsIds,
                tag_segmentation: tagSegmentation,
                data: notification,
                pages: pages,
                message_text: this.state.messageContent,
                model_type: subsFilter,
                model_gender: genderFilter,
            }
            //console.log('multipost data: ', multipostData);
            let i;


            //console.log('multiple post notification JSON: ', JSON.stringify(multipostData));
            //console.log('multiple post notification: ', multipostData);
            //console.log('multiple post call: ' + 'api/user/' + getCurrentUserId() + '/facebook_daily_notification');

            const res_bot = await http.post('api/user/' + getCurrentUserId() + '/facebook_daily_notification', {
                tag_ids: selectedTagsIds,
                tag_segmentation: tagSegmentation,
                data: notification,
                pages: pages,
                message_text: this.state.messageContent,
                model_type: subsFilter,
                model_gender: genderFilter
            }, {headers: {authorization: getJwt()}});


            //console.log('multiple response: ', res_bot);

            //console.log("sendFacebookNotificationMultiple res_bot.data.count ============ ", res_bot.data.count);
            //console.log("sendFacebookNotificationMultiple this.state.count_fb_subscrib ============ ", this.state.count_fb_subscrib);
            await this.setState({
                count_fb_subscrib: res_bot.data.count //+ this.state.count_fb_subscrib
                , //postStats: res_bot.data.postStats
                postStats: res_bot.data.postStats ? res_bot.data.postStats : [], count_push_subscrib: -2
            });
            this.setState({
                loaded: 2
            });

            const broadcast_click = {
                target: {
                    id: "broadcastClick"
                }
            };

            await this.setCountOfSubscribers();
            await this.setSentCountSubscribersByChannel();

            const data = {
                count_total_subscrib_sent: this.state.count_total_subscrib_sent, //postStats: this.state.post_count_by_channel,
                count_push_subscrib: -2,
                fb_sent: res_bot.data.count,
                pages,
                error: res_bot.data.error ? res_bot.data.error : ''

            };
            // console.log('multiple res bot:', res_bot)

            //testing if there are some unsuccessful sends for 24h window
            // if (res_bot.data.postStats[0].array_not_sent && res_bot.data.postStats[0].array_not_sent.length > 0) {
            //     //console.log('enters if')
            //     if (this.props.checked_send_all === false) {
            //         this.setState({
            //             windowModalActive: true,
            //             windowSentTo: res_bot.data.count
            //         })
            //     }
            // }
            // if ( !this.state.stopBroadcastModal ) {
            if (this.state.windowModalActive === false) {
                this.props.openModal(broadcast_click, data || 0);
                // }
            }
            let props = this.props;

            setTimeout(function () {
                props.loadingSubscribers(false);
            }, 2600)

        } catch (ex) {
            if (ex.response && ex.response.status === 404) toastr.error("You don't have any subscribers on the selected channels. Make sure you set up a campaign to get your followers to subscribe.");
            if (ex.response && ex.response.status === 401) {
                toastr.error(ex.response.data.message);
                this.props.history.push('/logout');
            }
        }

    };


    sendToAll = async (title, link) => {
        this.props.loadingSubscribers(true);
        /* Check if Webpush platform is enabled */
        let platforms_enabled = this.props.platforms_enabled;
        let webpush_platform_enabled = platforms_enabled && platforms_enabled.indexOf("wp") > -1;
        await this.setState({
            stopBroadcastModal: webpush_platform_enabled
        })


        let selectedSource = this.props.selectedSource;

        const {checked_channels} = this.props;

        let pages = [];
        let count_pages = 0;

        for (let i_check = 0; i_check < checked_channels.facebook.length; i_check++) {
            if (checked_channels.facebook[i_check].feed_id && selectedSource) {
                if (checked_channels.facebook[i_check].feed_id.toString() === selectedSource.toString() && checked_channels.facebook[i_check].connected === 'Connected') {
                    pages[count_pages] = checked_channels.facebook[i_check].page;
                    count_pages++;
                }
            }
        }

        this.sendFacebookNotification(title, link, pages);
        await this.setState({
            stopBroadcastModal: false
        })
        this.sendWebPushNotification(title, link, pages);
        let props = this.props;
        setTimeout(function () {
            props.loadingSubscribers(false);
        }, 2600)

    };

    setCountOfSubscribers = () => {
        let type_vip_subscribers = this.state.count_type_subscrib;
        //console.log("setCountOfSubscribers this.state.count_fb_subscrib ============ ", this.state.count_fb_subscrib);
        //console.log("setCountOfSubscribers type_vip_subscribers ===++++++===== ", type_vip_subscribers);
        let total_vip_subscribers = 0;
        let total_p = 0;

        if (typeof (this.state.count_push_subscrib) !== 'undefined' && this.state.count_push_subscrib > 0) {
            total_p = this.state.count_push_subscrib;
        }

        let total_fb = 0;

        if (typeof (this.state.count_fb_subscrib) !== 'undefined') {
            total_fb = this.state.count_fb_subscrib;
        }

        if (type_vip_subscribers === 'all') {
            total_vip_subscribers = total_p + total_fb;
        } else if (type_vip_subscribers === 'bot') {
            total_vip_subscribers = total_fb;
        } else if (type_vip_subscribers === 'push') {
            total_vip_subscribers = total_p;
        }
        //console.log("total_vip_subscribers ", total_vip_subscribers);

        this.setState({
            count_total_subscrib_sent: total_vip_subscribers
        });
    };

    setSentCountSubscribersByChannel = () => {
        //this.state.postStats.forEach(element => {
        //    console.log(element);
        //});
        let post_count_by_channel = [];
        let count = 0;
        this.state.postStats.forEach(element => {
            //console.log("setSentCountSubscribersByChannel element", element);
            //console.log("setSentCountSubscribersByChannel this.props.user_facebook_pages", this.props.user_facebook_pages);
            this.props.user_facebook_pages.forEach(elementPage => {
                //console.log("setSentCountSubscribersByChannel elementPage", elementPage);
                if (elementPage.id === element.channel_id) {
                    //console.log("element, elementPage", element, elementPage);
                    post_count_by_channel[count] = {
                        id: elementPage.id, page: elementPage.fb_page, count_sent: element.count_post_sent
                    };
                    count++;
                }
            });
        });

        this.setState({
            post_count_by_channel
        });

    };

    broadcastClick = async (e, selectedTags) => {
        // console.log('broadcast now')

        // ReactGA.event({
        //     category: 'Click',
        //     action: 'Broadcast post',
        //     userId: getCurrentUserId(),
        //     label: '',
        //     nonInteraction: true
        // });


        let invalidLinkError = false;
        let invalidLinks = '';
        if (e.target.id === "broadcast_multiple") {
            let indicator = 0;
            this.state.multiple_custom.map(post => {
                if (post.invalidLink === true) {
                    indicator = 1;
                    // console.log('invalidLinks before:', invalidLinks);
                    // console.log('invalid post id:', post.id);
                    // console.log('number of invalid post: ', post.id.substr(post.id.length - 1))
                    invalidLinks = String(invalidLinks) + String(post.id.substr(post.id.length - 1)) + ', '
                }
            });
            //console.log('invalid links string:', invalidLinks);

            if (indicator === 1) {
                invalidLinks = invalidLinks.substring(0, invalidLinks.length - 2);
                toastr.error('Double check the following links: ' + invalidLinks + '. They seem to be invalid.')
                invalidLinkError = true

            }

        } else {
            if (this.state.invalidLink === true) {
                toastr.error('There is a one or multiple invalid links!')
                invalidLinkError = true

            }
        }

        if (invalidLinkError === false) {
            // console.log('selected tags:', selectedTags);

            let pages = [];
            let count_pages = 0;
            let {checked_send_all, checked_channels, selectedSource} = this.props;

            if (this.props.checked_send_all === false) {
                if (this.props.checked_channels === []) {
                    toastr.warning('You must select at least one distribution channel!')
                }
            }

            let sent_wp_custom = false;
            if (e.target.id === "broadcast_multiple") {

                let errors = false;

                this.state.multiple_custom.forEach(function (entry) {
                    if (!entry.title || !entry.link) {
                        errors = true;
                    }
                });

                if (errors) {
                    toastr.error("Enter all titles and links first!");
                } else {
                    if (checked_send_all) {
                        for (let i_check = 0; i_check < checked_channels.facebook.length; i_check++) {
                            if (checked_channels.facebook[i_check].feed_id && checked_channels.facebook[i_check].feed_id.toString() === selectedSource.toString()) {
                                pages[count_pages] = checked_channels.facebook[i_check].page;
                                count_pages++;
                            }
                        }
                        if (pages.length > 0) {

                            let isValid = true;

                            this.state.multiple_custom.map(notification => {
                                if (isValid !== false) {
                                    isValid = this.validURL(notification.link)
                                }
                            });
                            //console.log('multiple is valid: ', isValid);

                            if (isValid === true) {
                                this.setState({
                                    loaded: 1
                                });
                                this.sendFacebookNotificationMultiple(this.state.multiple_custom, pages, selectedTags);
                                toastr.info("Sending your post in progress...");
                            } else {
                                toastr.error("Looks like some of your links is invalid. Please use a valid link and try broadcasting again.")

                            }
                        }
                    } else {

                        // console.log('dont send all, checked_channels-pages: ', checked_channels.facebook);

                        if (checked_channels.facebook.length > 0) {
                            for (let i_check = 0; i_check < checked_channels.facebook.length; i_check++) {
                                if (checked_channels.facebook[i_check].checked && checked_channels.facebook[i_check].connected === 'Connected' && checked_channels.facebook[i_check].feed_id.toString() === selectedSource.toString()) {
                                    pages[count_pages] = checked_channels.facebook[i_check].page;
                                    count_pages++;
                                }

                            }
                            if (pages.length > 0) {
                                let isValid = true

                                this.state.multiple_custom.map(notification => {
                                    if (isValid !== false) {
                                        isValid = this.validURL(notification.link)
                                    }
                                });
                                //console.log('multiple is valid: ', isValid);

                                if (isValid === true) {
                                    this.setState({
                                        loaded: 1
                                    });
                                    this.sendFacebookNotificationMultiple(this.state.multiple_custom, pages, selectedTags);
                                    toastr.info("Sending your post in progress...");
                                } else {
                                    toastr.error("Looks like some of your links is invalid. Please use a valid link and try broadcasting again.")

                                }
                            }
                        }

                    }
                    this.setState({
                        count_push_subscrib: 0, count_fb_subscrib: 0
                    });
                }

            } else {
                const {title, link} = this.state;

                if (title && link) {
                    if (checked_send_all) {
                        let isValidLink = this.validURL(link);

                        //console.log('is valid link: ', isValidLink);

                        if (isValidLink === false) {

                            toastr.error("Looks like your link is invalid. Please use a valid link and try broadcasting again.")
                        } else {
                            this.setState({
                                loaded: 1
                            });
                            this.sendToAll(title, link);
                            toastr.info("Sending your post in progress...")
                        }
                    } else {
                        // console.log('checked channels - facebook: ', checked_channels.facebook);
                        if (checked_channels.facebook.length > 0) {
                            // console.log('checked channels - length', checked_channels.facebook.length);
                            for (let i_check = 0; i_check < checked_channels.facebook.length; i_check++) {

                                if (checked_channels.facebook[i_check].checked && checked_channels.facebook[i_check].connected === 'Connected' && checked_channels.facebook[i_check].feed_id.toString() === selectedSource.toString()) {
                                    pages[count_pages] = checked_channels.facebook[i_check].page;
                                    count_pages++;
                                }
                            }
                            // console.log('pages: ', pages);
                            if (pages.length > 0) {
                                let isValidLink = this.validURL(link);

                                //console.log('is valid link: ', isValidLink);

                                if (isValidLink === false) {

                                    toastr.error("Looks like your link is invalid. Please use a valid link and try broadcasting again.")
                                } else {
                                    this.setState({
                                        loaded: 1
                                    });
                                    this.sendFacebookNotification(title, link, pages, selectedTags);


                                    if (!sent_wp_custom) {
                                        toastr.info("Sending your post in progress...")
                                    }
                                }
                            } else {
                                if (!sent_wp_custom) {

                                    if (checked_channels.web_push === false && checked_channels.facebook < 1) {

                                        toastr.info("Please, select channels to send to.");
                                    }

                                    this.setState({
                                        loaded: 0
                                    });
                                }
                            }
                        }
                        if (checked_channels.web_push) {
                            if (checked_channels.facebook.length < 1) {
                                pages = await [];
                            }
                            let isValidLink = this.validURL(link);

                            //console.log('is valid link: ', isValidLink);

                            if (isValidLink === false) {

                                toastr.error("Looks like your link is invalid. Please use a valid link and try broadcasting again.")
                            } else {
                                this.sendWebPushNotification(title, link, pages);

                                sent_wp_custom = true;
                                toastr.info("Sending your post in progress...")
                            }
                        }
                    }
                    this.setState({
                        count_push_subscrib: 0, count_fb_subscrib: 0
                    });
                } else {
                    toastr.error("Both 'Title' and 'Link' fields are required");
                    this.setState({
                        loaded: 0
                    });
                }
            }

            //const broadcast_click = {target:{id:"broadcastClick"}};
            //this.setCountOfSubscribers();
            //this.props.openModal(broadcast_click, this.state.count_total_subscrib_sent || 55);
        }
    };

    switchType = (event) => {
        const {id} = event.target;
        this.setState({
            messageContent: '', showMessage: false, subsFilter: 'all-subs', genderFilter: 'all-genders'
        });
        if (id === "multiple") {
            this.setState({
                showSingle: false, title: "", link: '', imageFromLink: "", multiple_custom: [{
                    imageFromLink: "", title: "", get_title_from_url: true, link: "", id: 'multiple_custom_01'
                }, {
                    imageFromLink: "", title: "", get_title_from_url: true, link: "", id: 'multiple_custom_02'
                }]
            });
        } else {
            this.setState({
                showSingle: true, title: "", link: '', imageFromLink: "", multiple_custom: [{
                    imageFromLink: "", title: "", get_title_from_url: true, link: "", id: 'multiple_custom_01'
                }, {
                    imageFromLink: "", title: "", get_title_from_url: true, link: "", id: 'multiple_custom_02'
                }]
            });
        }
    };

    isValidUrl = (userInput) => {

        //console.log('isValidUrl activated');
        let res = userInput.match(/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g);
        if (res == null) {
            return false;
        } else {
            return true;
        }
    }

    getLinkData = async (index = null, value = null, link = null) => {
        // console.log('value:', value);
        // console.log('link: ', link);
        // console.log('index:', index)
        let validLink = '';
        if (this.state.showSingle === false) {
            if (link !== null) {
                validLink = await this.isValidUrl(value);
            }
        } else {
            validLink = await this.isValidUrl(this.state.link)
        }


        if (validLink === true) {

            this.setState({
                loading_title: true
            });

            let loading_multiple_items = this.state.loading_title_multiple_custom;

            const API_META = "/api/url_metadata";

            let URL_META = this.state.link;
            let n = URL_META.startsWith('http');
            // console.log('value:', URL_META);
            // console.log('n:', n);
            if (n === false) {
                URL_META = 'http://' + URL_META
                this.setState({link: URL_META});
            }
            // console.log("getLinkData", API_META+URL_META);

            if (link === "link") {


                URL_META = this.state.multiple_custom[index].link;
                let n = URL_META.startsWith('http');
                //console.log('value:', URL_META);
                //console.log('n:', n);
                if (n === false) {
                    URL_META = 'http://' + URL_META
                }
                //console.log('http value', value);


                loading_multiple_items[index].loading_title = true;

                const loading_title_multiple = await update(this.state.loading_title_multiple_custom, {$splice: [[index, 1, {loading_title: true}]]});  // array.splice(start, deleteCount, item1)

                this.setState({
                    loading_title_multiple_custom: loading_title_multiple
                });
            }

            try {
                const result = await http.post(API_META, {
                    'url': URL_META
                });

                // console.log('fetch result:', result);
                if (result.data) {
                    if (result.status !== "ERROR") {
                        if (link === "link") {
                            // console.log('getting value of multiple');
                            let multiple_items = this.state.multiple_custom;

                            multiple_items[index].imageFromLink = result.data.image ? result.data.image : "/img/no-photo-found.jpeg";
                            multiple_items[index].title = result.data.title || "";
                            const multiple_custom = update(this.state.multiple_custom, {$splice: [[index, 1, multiple_items[index]]]});  // array.splice(start, deleteCount, item1)
                            loading_multiple_items[index].loading_title = false;
                            const loading_title_multiple_custom = update(this.state.loading_title_multiple_custom, {$splice: [[index, 1, loading_multiple_items[index]]]});  // array.splice(start, deleteCount, item1)
                            if (multiple_custom[index].get_title_from_url === false) {
                                multiple_custom[index].title = ''
                            }
                            multiple_custom[index].invalidLink = false;
                            await this.setState({
                                invalidLink: false,
                                multiple_custom: multiple_custom,
                                loading_title_multiple_custom: loading_title_multiple_custom
                            });
                        } else {

                            //console.log('getting value of single')
                            await this.setState({
                                invalidLink: false,
                                imageFromLink: result.data.image ? result.data.image : "/img/no-photo-found.jpeg"
                            });

                            if (this.state.showSingle === true) {
                                if (this.state.get_title_from_url === true) {
                                    await this.updateValue('title', result.data.title || "");
                                }
                            } else {
                                //console.log('entered here');
                                if (this.state.multiple_custom[index].get_title_from_url === true) {
                                    await this.updateValue('title', result.data.title || "");
                                }

                            }

                        }
                    } else {
                        if (link === "link") {
                            let multiple_items = this.state.multiple_custom;

                            multiple_items[index].imageFromLink = "https://onaliternote.files.wordpress.com/2016/11/wp-1480230666843.jpg";

                            const multiple_custom = update(this.state.multiple_custom, {$splice: [[index, 1, multiple_items[index]]]});  // array.splice(start, deleteCount, item1)

                            await this.setState({
                                invalidLink: false, multiple_custom: multiple_custom
                            });
                        } else {
                            await this.setState({
                                invalidLink: false,
                                imageFromLink: "https://onaliternote.files.wordpress.com/2016/11/wp-1480230666843.jpg"
                            });
                        }
                    }
                } else {
                    toastr.error("It appears that the link isn't pointing to a valid website!")

                    //console.log(loadingTitle);
                    // console.log('index on blur:', index);
                    if (index === null) {
                        await this.setState({
                            invalidLink: true, loading_title: false,

                        })
                    } else {
                        let loadingTitle = this.state.loading_title_multiple_custom;
                        loadingTitle.map(loading => {
                            loading.loading_title = false
                        });
                        let multipleCustom = [...this.state.multiple_custom];
                        multipleCustom[index].invalidLink = true;

                        await this.setState({
                            multiple_custom: multipleCustom,
                            loading_title: false,
                            loading_title_multiple_custom: loadingTitle
                        })
                    }


                }
            } catch (ex) {
                toastr.error("The API we're using to fetch the link's mata-data is currently down. Please try again in a few minutes. ");

                await this.setState({
                    loading_title: false, loading_title_multiple_custom: [{
                        loading_title: false
                    }, {
                        loading_title: false
                    }]
                });
            }

            this.setState({
                loading_title: false
            });
        } else {
            // toastr.error('Please provide a valid link')
        }
    };
    resetInvalidLink = async () => {
        this.setState({invalidLink: false})
    }
    calculateMultipost = () => {
        //console.log("calculateMultipost ");
        let posts = $('#multiple-posts .preview-post').length + 1;
        //console.log("posts ", posts);
        let multipleWidth = posts * 256;
        $('.multiple-posts').css('width', multipleWidth + 'px')
    };

    addMorePosts = () => {
        let multiple_custom_og = this.state.multiple_custom;
        let loading_multiple_items_og = this.state.loading_title_multiple_custom;
        if (multiple_custom_og.length > 8) {
            toastr.info("Maximum number of posts added!");
        } else {
            multiple_custom_og[multiple_custom_og.length] = {
                imageFromLink: "",
                title: "",
                get_title_from_url: true,
                link: "",
                id: 'multiple_custom_0' + (multiple_custom_og.length + 1),
                invalidLink: false
            };
            loading_multiple_items_og[loading_multiple_items_og.length] = {
                loading_title: false
            };
            this.setState({
                multiple_custom: multiple_custom_og, loading_title_multiple_custom: loading_multiple_items_og
            });

            this.calculateMultipost();
        }
    };
    removeMultipost = async (visiblePost) => {
        // console.log('visible:', visiblePost)

        let multiple_custom = await [...this.state.multiple_custom];

        let loading_title_multiple_custom = await [...this.state.loading_title_multiple_custom];

        await multiple_custom.splice(visiblePost, 1);
        await loading_title_multiple_custom.splice(visiblePost, 1);
        // console.log('multiplePosts: ', multiple_custom);
        // console.log('loadingTitle: ', loading_title_multiple_custom)
        await this.setState({
            multiple_custom, loading_title_multiple_custom
        })
        // console.log('removeMultiPost state: ', this.state.multiple_custom, this.state.loading_title_multiple_custom)
    };


    async componentDidMount() {
        //ReactGA.pageview(window.location.pathname + window.location.search);
        // console.log('selected source id: ', this.props.selectedSource);
        // let selectedSource = await this.props.user.sources.data.filter(
        //     source => source.id.toString() === this.props.selectedSource
        // )
        // console.log('selectedSource full: ', selectedSource)
        // this.setState({
        //     selectedSourceFull: selectedSource})
        //
        // if (selectedSource[0]) {
        //
        //     //collecting remaining free messages
        //     let facebookPlatform = selectedSource[0].platforms.filter(
        //         platform => platform.platform === 'fb'
        //     )
        //     console.log('facebook platform :', facebookPlatform);
        //
        //
        //     await this.setState({
        //         sourcePlan: selectedSource[0] ? selectedSource[0].platforms[0].plan : '',
        //     })
        // }
        if (localStorage.getItem('multipost') === 'true') {
            this.setState({showSingle: false});
            localStorage.removeItem('multipost')
        }
        toastr.options = {
            closeButton: true,
            positionClass: "toast-bottom-full-width",
            showDuration: "300",
            hideDuration: "1000",
            timeOut: "8000",
            extendedTimeOut: "1000",
        };

        //hiding emoji picker when clicked around
        // console.log('this.props.location1: ', this.props.location)
        const postDataPassed = this.props.location.state ? this.props.location.state.post : '';
        const type = this.props.location.state && this.props.location.state.type ? this.props.location.state.type : '';

        if (postDataPassed) {
            //console.log('Entered u func: ', postDataPassed)
            let multiple_custom = this.state.multiple_custom;
            multiple_custom[0].link = postDataPassed.short_url;
            await this.setState({
                link: postDataPassed.short_url, multiple_custom
            })
            await this.updateValue('link', postDataPassed.short_url);
            await this.getLinkData()
        }

        if (type && type === 'carousel') {
            this.setState({showSingle: false})
        }

        try {
            const result = await http.get('api/user/' + getCurrentUserId(), {headers: {authorization: getJwt()}});
            const data = result.data;
            this.setState({message: data});

            if (!data) {
                toastr.error("User id does not match. :(  Please log in again.");
                this.props.history.push('/logout');
            } else {
                setCurrentUserName(data.name);
            }
        } catch (ex) {
            if (ex.response && ex.response.status === 404) toastr.error("User Something went wrong... Please refresh and try again.");
            if (ex.response && ex.response.status === 401) {
                //    let errors = { ...this.state.errors }
                //console.log(ex.response.data);
                toastr.error(ex.response.data.message);
                //window.location = "/";
                this.props.history.push('/logout');
            }
        }

    }


    updateValue = (fieldName, value, field_id = null) => {
        // console.log('Inside of updateValue: ', fieldName, value, field_id)
        if (fieldName.includes('multiple_custom')) {

            let multiple_custom_og = this.state.multiple_custom;
            let multiple_item = multiple_custom_og.filter(item => (item.id === fieldName))[0] || {};

            const index = multiple_custom_og.findIndex((item) => item.id === fieldName);

            multiple_item[field_id] = value;
            const multiple_custom = update(multiple_custom_og, {$splice: [[index, 1, multiple_item]]});  // array.splice(start, deleteCount, item1)

            this.setState({
                multiple_custom: multiple_custom
            });
            // console.log('oplaio je 1: ', this.state.multiple_custom)
        } else {
            this.setState({
                [fieldName]: value
            })
        }
    };

    handleChange = (selectedOption) => {
        this.setState({selectedOption});
        //console.log(`Selected: ${selectedOption.label}`);
    };

    handleGetTitleFromUrl = (e) => {
        const id = e.target.id;
        const name = e.target.name;
        if (name.includes('multiple_custom')) {

            let multiple_items = this.state.multiple_custom;

            multiple_items[id].get_title_from_url = !multiple_items[id].get_title_from_url;
            if (!multiple_items[id].get_title_from_url) {
                multiple_items[id].title = "";
            }
            const multiple_custom = update(this.state.multiple_custom, {$splice: [[id, 1, multiple_items[id]]]});  // array.splice(start, deleteCount, item1)


            this.setState({
                multiple_custom: multiple_custom
            })

        } else {
            if (this.state.get_title_from_url) {
                this.setState({
                    title: ""
                });
            }
            this.setState({
                get_title_from_url: !this.state.get_title_from_url
            });
        }
    };

    handleMessage = (message) => {
        this.setState({characterCount: message.length, messageContent: message});

    };

    handleEmoji = (e) => {
        //console.log('clicked:', e.native);

        document.querySelector('#post-message-text').value += e.native;
        let messageText = document.querySelector('#post-message-text').value;
        this.setState({characterCount: messageText.length, messageContent: messageText})
        document.querySelector('#post-message-text').focus();

    };
    toggleEmoji = async () => {
        let x = document.querySelector('.emoji-mart');

        if (x.style.display === "none") {
            document.querySelector('#post-message-text').focus();
            x.style.display = "block";
            await this.setState({native: true})
        } else {
            x.style.display = "none";
            await this.setState({native: true})
        }
    };
    toggleMessage = () => {
        let message = this.state.showMessage;
        let messageContent = this.state.messageContent;
        if (message === true) {
            messageContent = '';

        }
        this.setState({
            showMessage: !message, messageContent
        });
    };
    selectSubsFilter = (subsFilter) => {
        this.setState({
            subsFilter: subsFilter
        })
    }
    selectGenderFilter = (genderFilter) => {
        this.setState({
            genderFilter: genderFilter
        })
    }
    togglePostsNumber = (e) => {
        //console.log('single/multiple: ', e.target.id)

        let postsNumberSingle = e.target.id === 'single' ? true : false
        this.setState({showSingle: postsNumberSingle})

    };

    upgradeToProFeature = () => {
        //console.log('upgrade to pro modal')
        this.setState({
            upgradeModalActive: true,
            upgradeModalTitle: 'Segmentation is not available on your current plan.',
            upgradeModalContent: `<p>Check out the plans and features below and choose one that suits your needs.<br>
                Our team is available from the chat if you need any assistance.</p>`
        })
    }

    limitReached = async () => {
        //console.log('limit reached modal')
        if (this.state.sourcePlan === 'free_plan') {
            await this.setState({
                upgradeModalTitle: 'Limit Reached!',
                upgradeModalContent: 'Limit reached on Free Plan. Upgrade to PRO!',
                upgradeModalActive: true
            })
        } else {
            await this.setState({
                upgradeModalTitle: 'FB Messenger 5.000 limit reached ',
                upgradeModalContent: 'You have now spent all of your included Facebook Messenger credits for this month. ' + 'From now on you will be charged $2 per 1.000 FB Messenger notifications.' + 'You will receive your next bundle of 5.000 messages',
                upgradeModalActive: true

            })
        }
    }

    openUpgradeModal = () => {
        this.setState({
            upgradeModalActive: true
        })
    }

    handleFacebookPages = async () => {
        const sources = this.props.sources || {};
        const feeds_shared = this.props.feeds_shared || {};
        let platforms_enabled = this.props.platforms_enabled || [];
        const selected_src_id = this.props.selectedSource || "";


    }

    render() {
        const sources = this.props.sources || {};
        const feeds_shared = this.props.feeds_shared || {};
        let platforms_enabled = this.props.platforms_enabled || [];
        const selected_src_id = this.props.selectedSource || "";


        if (!selected_src_id) {
            return <React.Fragment>
                <h1 className='main-title'>Facebook Message</h1>
                <p className="nav-back" onClick={() => this.props.history.push('/new')}><i
                    className="fas fa-chevron-left"></i> New Campaign</p>
                {sources.length ? <div className="row">
                    <div className="col-xs-12 text-center no-feeds-containers">
                        <div className="feed-msg">
                            <img className='emitto-mark' src="/img/emitto-mark.png" alt="Emitto Mark"/>
                            <p className="text-center ">{authService.getCurrentUserName()}</p>
                            <p>It looks
                                like you haven't set up any workspaces yet. Add your first project, and
                                start growing your audience.</p>
                            <img className='cat-img' src="/img/cat-transparent.gif" alt="No Workspaces"/>
                        </div>
                        <button className='btn-m btn-action' onClick={this.props.addSource} type="button">
                            Create your first workspace
                        </button>
                    </div>
                </div> : <NoFeeds userFullName={this.props.userFullName}/>}

            </React.Fragment>
        }
        let myData = this.state.message.data || {};
        // console.log('message: ', myData)

        let myData_pages = [];
        if (myData.facebook_pages) {
            myData_pages = myData.facebook_pages.data;
        }
        const facebook_pages_shared = myData.facebook_pages_shared;


        if (facebook_pages_shared && facebook_pages_shared.length) {
            myData_pages = [...myData_pages, ...facebook_pages_shared];
        }

        // console.log('myData_pages: ', myData_pages)

        //console.log('facebook_pages_shared', facebook_pages_shared)

        //ENABLE
        // console.log(" console.log(this.props.facebook_pages_shared);",  this.props.facebook_pages_shared);
        // console.log(" console.log(this.props.platforms_enabled);",  this.props.platforms_enabled);
        // console.log("myData_pagesmyData_pagesmyData_pagesmyData_pagesmyData_pages);",  myData_pages);

        let facebook_platform_enabled = platforms_enabled && platforms_enabled.indexOf("fb") > -1;
        let count_pages = myData_pages ? myData_pages.length : "";

        // console.log(" ENABLE   count_pages;",  count_pages);
        let page_source_connected = (count_pages && selected_src_id) ? myData_pages.filter(el => {
            return (el.feed_id && el.feed_id.toString() === selected_src_id.toString())
        }) : "";
        // console.log(" ENABLE   page_source_connected;",  page_source_connected);
        if (page_source_connected.length && !facebook_platform_enabled) {
            // this.setState({clicked_fb: true});
            platforms_enabled = [...platforms_enabled, 'fb'];

        }
        // else
        // {
        //     this.setState({clicked_fb: false});
        // }

        // console.log(" ENABLE  platforms_enabled);",  platforms_enabled);
        let pages_options = [];
        let j_page = 0;
        for (let i_page = 0; i_page < myData_pages.length; i_page++) {
            pages_options[j_page] = {
                value: myData_pages[i_page].fb_page_id, label: myData_pages[i_page].fb_page
            };
            j_page++;
        }

        //let type_vip_subscribers = this.state.count_type_subscrib;
        let get_title_from_url = this.state.get_title_from_url;


        let posts_tab_class_single = "posts-tab active";
        let posts_tab_class_multiple = "posts-tab";
        if (!this.state.showSingle) {
            posts_tab_class_single = "posts-tab";
            posts_tab_class_multiple = "posts-tab active";
        }

        let multiple_custom = this.state.multiple_custom;

        return <React.Fragment>
            <h1 className='main-title'>Facebook Message</h1>
            <p className="nav-back" onClick={() => this.props.history.push('/new')}><i
                className="fas fa-chevron-left"></i> New Campaign</p>

            <div
                //onClick={this.handleWhen}
                className='flex-direction-row posts-number m-lg-b'
            >
                <div
                    onClick={e => this.togglePostsNumber(e)}
                    className={this.state.showSingle ? "post-number-selection active" : 'post-number-selection'}
                    id='single'>
                    Single Message
                </div>
                <div
                    onClick={this.togglePostsNumber}
                    className={this.state.showSingle === false ? "post-number-selection active" : 'post-number-selection'}
                    id='multiple'>
                    Carousel Message
                </div>
            </div>

            {this.state.showSingle ? <FacebookSinglePost
                    postUrl={this.state.link}
                    updateValue={this.updateValue}
                    onBlur={this.getLinkData}
                    previewTitle={this.state.title}
                    previewLink={this.state.imageFromLink}
                    pages={myData_pages}
                    website={myData.website_url}
                    checkAllPagesAndChannels={this.props.checkAllPagesAndChannels}
                    checkPagesAndChannels={this.props.checkPagesAndChannels}
                    checked_send_all={this.props.checked_send_all}
                    checked_channels={this.props.checked_channels}
                    broadcastClick={this.broadcastClick}
                    broadCastNumOfSubscribers={this.state.count_total_subscrib_sent}
                    sources={sources}
                    feeds_shared={feeds_shared}
                    selectedSource={selected_src_id}
                    handleGetTitleFromUrl={this.handleGetTitleFromUrl}
                    get_title_from_url={get_title_from_url}
                    loading_title={this.state.loading_title}
                    openModal={this.props.openModal}
                    loaded={this.state.loaded}
                    platforms_enabled={platforms_enabled}
                    history={this.props.history}
                    handleMessage={this.handleMessage}
                    characterCount={this.state.characterCount}
                    handleEmoji={this.handleEmoji}
                    toggleEmoji={this.toggleEmoji}
                    messageContent={this.state.messageContent}
                    showMessage={this.state.showMessage}
                    toggleMessage={this.toggleMessage}

                    subsFilter={this.state.subsFilter}
                    selectSubsFilter={this.selectSubsFilter}
                    genderFilter={this.state.genderFilter}
                    selectGenderFilter={this.selectGenderFilter}
                    tags={this.props.tags}
                    filterTags={this.props.filterTags}
                    native={this.state.native}
                    sourcePlan={this.state.sourcePlan}
                    openUpgradeModal={this.openUpgradeModal}
                    limitReached={this.limitReached}
                    upgradeToProFeature={this.upgradeToProFeature}
                    user={this.props.user}
                    currentPlanLimitations={this.state.currentPlanLimitations}

                />

                :

                <FacebookMultiplePost
                    message={this.state.message}
                    postUrl={this.state.link}
                    updateValue={this.updateValue}
                    onBlur={this.getLinkData}
                    addMorePosts={this.addMorePosts}
                    pages={myData_pages}
                    website={myData.website_url}
                    checkAllPagesAndChannels={this.props.checkAllPagesAndChannels}
                    checkPagesAndChannels={this.props.checkPagesAndChannels}
                    checked_send_all={this.props.checked_send_all}
                    checked_channels={this.props.checked_channels}
                    broadcastClick={this.broadcastClick}
                    broadCastNumOfSubscribers={this.state.count_total_subscrib_sent}
                    sources={sources}
                    selectedSource={selected_src_id}
                    multiple_custom={multiple_custom}
                    handleGetTitleFromUrl={this.handleGetTitleFromUrl}
                    loading_title_multiple_custom={this.state.loading_title_multiple_custom}
                    openModal={this.props.openModal}
                    loaded={this.state.loaded}
                    platforms_enabled={platforms_enabled}
                    history={this.props.history}

                    //message and emoji props
                    handleMessage={this.handleMessage}
                    characterCount={this.state.characterCount}
                    handleEmoji={this.handleEmoji}
                    toggleEmoji={this.toggleEmoji}
                    messageContent={this.state.messageContent}
                    showMessage={this.state.showMessage}
                    toggleMessage={this.toggleMessage}

                    //filters props
                    subsFilter={this.state.subsFilter}
                    selectSubsFilter={this.selectSubsFilter}
                    genderFilter={this.state.genderFilter}
                    selectGenderFilter={this.selectGenderFilter}
                    tags={this.props.tags}
                    filterTags={this.props.filterTags}
                    removeMultipost={this.removeMultipost}
                    native={this.state.native}
                    resetInvalidLink={this.resetInvalidLink}
                    sourcePlan={this.state.sourcePlan}
                    openUpgradeModal={this.openUpgradeModal}
                    limitReached={this.limitReached}
                    upgradeToProFeature={this.upgradeToProFeature}
                    user={this.props.user}
                    currentPlanLimitations={this.state.currentPlanLimitations}

                />}
            {/*{ console.log('platforms_enabled in CustomPosts.js: ', platforms_enabled)}*/}
            <WindowExpiredModal
                showModal={this.state.windowModalActive}
                handleClose={() => this.setState({windowModalActive: false})}
                maxWidth={500}
                history={this.props.history}
                sentTo={this.state.windowSentTo}
            />

        </React.Fragment>
    }
}

export default FacebookMessageCustomPost;